/* @jsx h */
import { defineComponent, h } from "vue";
import { RewardDays } from "@lemmonhq/types";
import { DaySelect } from "../../../components/DaySelect";
import { daysOfWeek as days } from "@lemmonhq/orders";

export type DaysEditorProps = {
  value: RewardDays;
  onChange: (days: RewardDays) => void;
};

export const DaysEditor = defineComponent<DaysEditorProps>({
  name: "DaysEditor",
  props: ["value", "onChange"],
  setup(props) {
    const hasSchedule = () => {
      return Object.keys(props.value).length > 0;
    };

    const clearSchedule = () => {
      props.onChange({});
    };

    const setAlwaysActive = () => {
      const allDays: RewardDays = {};
      days.forEach((day) => {
        allDays[day] = [{ start_time: "00:00", end_time: "23:59" }];
      });

      props.onChange(allDays);
    };

    return () => (
      <div class="card ">
        <div class="card-body p-0">
          <div class="flex items-center justify-between mb-4">
            <h4 class="card-title text-accent text-lg flex items-center gap-2">
              <div class="w-3 h-3 bg-primary rounded-full animate-pulse"></div>
              Active Days & Times
            </h4>

            <div class="flex gap-2">
              <button
                type="button"
                onClick={setAlwaysActive}
                class="btn btn-sm btn-primary"
              >
                Always Active
              </button>

              {hasSchedule() && (
                <button
                  type="button"
                  onClick={clearSchedule}
                  class="btn btn-sm btn-ghost btn-square"
                  title="Clear Schedule"
                >
                  <span class="material-symbols-outlined text-lg">
                    event_busy
                  </span>
                </button>
              )}
            </div>
          </div>

          {!hasSchedule() ? (
            <div class="text-center py-8">
              <div class="text-6xl mb-4">📅</div>
              <div class="text-lg font-medium mb-2">No Schedule Set</div>
              <div class="text-base-content/70 mb-4">
                This promotion will be active 24/7 when enabled. Add a schedule
                to restrict when it's available.
              </div>
              <button
                type="button"
                onClick={() =>
                  props.onChange({
                    monday: [{ start_time: "09:00", end_time: "17:00" }],
                  })
                }
                class="btn btn-primary"
              >
                Add Schedule
              </button>
            </div>
          ) : (
            <div>
              <div class="alert alert-info/20 border-info/30 mb-4">
                <div class="flex items-center gap-2">
                  <div class="text-info text-xl">⏰</div>
                  <div>
                    <div class="font-medium text-info">Scheduled Promotion</div>
                    <div class="text-sm text-info/80">
                      This promotion will only be active during the specified
                      times
                    </div>
                  </div>
                </div>
              </div>

              <DaySelect value={props.value} onChange={props.onChange} />
            </div>
          )}
        </div>
      </div>
    );
  },
});
